module.exports = __webpack_public_path__ + "img/applybpo2.96631476.png";